export default "__VITE_ASSET__B2g_IIUI__"